import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromStore from '../../store';
import { pluck, take } from 'rxjs/operators';
import { AChild, Parent } from '../../models/data-models';
import { ChildrenState } from '../../store/reducers/children.reducer';
import * as generalActions from '../../store/actions/general.action';
import { ChatService } from '../../services/ChatService/chat.service';
import { replyGiversOrReceivers } from '../../models/GiverResponse';
import { GeneralService } from '../../services/generalService/general.service';

@Component({
  selector: 'app-submit-request',
  templateUrl: './submit-request.component.html',
  styleUrls: ['./submit-request.component.css']
})
export class SubmitRequestComponent implements OnInit {
  loading = false;

  constructor(
    private store: Store,
    private chatservice: ChatService,
    private generalservice: GeneralService,
  ) {
  }

  async ngOnInit() {
    await this.submitRequest();
  }

  async submitRequest() {
    this.loading = true;
    let childArray: Array<Partial<AChild>>;
    let parent: Parent;
    let tuitionFeesTotal: number;
    //  Please refactor this code later
    // get child
    this.store.select(fromStore.getCurrentChildState).pipe(take(1)).pipe(pluck('child_info')).subscribe(val => {
      childArray = Array.from((val as Map<string, Partial<AChild>>).values());
    });
    const arrayOfChildId: { id: any, tuition: string }[] = childArray.map(element => {
      return {
        id: element.child_id || element.id,
        tuition: element.tuition_fees || element.tuition,
        uniform: element.hasOwnProperty('uniform') ? element.uniform : null,
        transport: element.hasOwnProperty('transport') ? element.transport : null,
        feeding: element.hasOwnProperty('feeding') ? element.feeding : null
      };
    });
    // get parent
    this.store.select(fromStore.getCurrentParentInfo).pipe(take(1)).subscribe(val => {
      parent = val as Parent;
    });
    // get tuition
    this.store.select(fromStore.getCurrentChildState).pipe(take(1)).subscribe((val: any) => {
      const { total_tuition_fees } = val as ChildrenState;
      tuitionFeesTotal = total_tuition_fees;
    });
    const rf = sessionStorage.getItem('repaymentFrequency');
    const res = await this.chatservice.sendLoanRequest({
      school_id: parent.school_id || 1,
      guardian_id: parent.guardian,
      loan_amount: tuitionFeesTotal.toString(),
      child_data: arrayOfChildId,
      repayment_frequency: rf === 'null' ? '3' : rf
    });
    const updatedParents: Partial<Parent> = { ...parent, loan_request: res.request };
    this.store.dispatch(new generalActions.addParents(updatedParents));
    this.submitRequestLend();
    this.loading = false;
  }

  submitRequestLend() {
    let totalFees = 0;
    let parent = null;
    this.store.select(fromStore.getCurrentChildState).pipe(take(1)).subscribe((val: any) => {
      const { total_tuition_fees } = val as ChildrenState;
      totalFees += total_tuition_fees;
    });
    this.store.select(fromStore.getParentState).pipe(pluck('parent_info')).subscribe(async val => {
      parent = (val as Parent);
    });
    const profileImage = sessionStorage.getItem('parent_picture');
    const payload = {
      request: {
        amount: totalFees,
        tenor: 3
      },
      profile: {
        user_id: null,
        full_name: parent.full_name,
        email: parent.email,
        phone: parent.phone,
        profile_image: profileImage
      },
      home_address: {
        address: parent.address,
        lga_id: parent.lga,
        state_id: parent.state
      },
      work: parent.work_info,
      school_id: parent.school_id,
      parent_id: parent.guardian,
      school_request_id: parent.loan_request
    };
    this.chatservice.createLoanRequestOnLend(payload);
    // const requestId = res.dd;
    // await this.chatservice.updateCreditClanRequestId(parent.loan_request, requestId);
  }

  sendChat() {
    const url = `https://wa.me/+2349155577731?text=Hello+Creditclan,+I+have+completed+my+application`;
    window.open(url, '_blank');
    this.finish();
  }

  finish() {
    this.generalservice.handleFlowController('');
    const responseFromParent = new replyGiversOrReceivers(
      `I have provided all relevant information`, 'right'
    );
    this.generalservice.nextChatbotReplyToGiver = new replyGiversOrReceivers(
      `Thank you for your application. Your School has been notified to review your request.`, 'left',
    );
    this.generalservice.ctrlDisableTheButtonsOfPreviousListElement('allow');
    this.generalservice.responseDisplayNotifier(responseFromParent);
  }
}
